export default "__VITE_ASSET__ac4177fe__"